export { default } from './PostCardSlider';
